// 计算 题目那边要展示的数据
export function computeAccuracy(molecule, denominator) {
    console.log('molecule', molecule);
    return String((Math.round((Number(molecule)/Number(denominator)*10000))/100).toFixed(0)) + '%';
}